<script>
import {deviceApi} from "@/api/chemical";
import {formatImage} from "@/utils/format";
import UtUpload from "@/components/UtUpload.vue";

export default {
  name: 'ChemicalDeviceList',
  components: {UtUpload},
  data() {
    return {
      type: 'chemicalDevice',
      typeList: [],
      current : 1,
      size: 30,
      deviceType : {},
      visible: false,
      loading: false
    }
  },
  mounted() {
    this.fetchTypeList()
  },
  methods:{
    formatImage,
    async fetchTypeList() {
      const res = await deviceApi.pageTypeList({
        current: this.current,
        size: this.size
      })
      this.typeList = res.result.records
    },
    close() {
      this.visible = false;
      this.deviceType = {}
    },
    handleAdd(){
      this.visible = true
    },
    handleEdit(row) {
      this.visible = true
      this.deviceType = row
    },
    async handleSubmit(){
      this.loading = true
      console.log('submit data' ,this.deviceType)
      const res = await deviceApi.saveOrUpdate(this.deviceType)
      if (res && res.code === '0000'){
        this.$message.success('新增成功')
        this.close()
        this.fetchTypeList()
      }
      this.loading = false
    }
  }
}

</script>

<template>
  <div>
    <el-card>
      <div slot="header">
        <el-button type="primary" @click="handleAdd">添加</el-button>
      </div>
      <el-table :data="typeList" border  stripe highlight-current-row>
        <el-table-column label="类型编码" prop="code"  />
        <el-table-column label="分类名称" prop="name"  />
        <el-table-column label="说明" prop="comment" min-width="120" show-overflow-tooltip  />
        <el-table-column label="图片" >
          <template slot-scope="scope">
            <el-image style=" height: 30px" :src="formatImage(scope.row.imgUrl)" fit="fill" lazy/>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="80">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-drawer :title="deviceType.id ? '编辑' : '添加'" :visible.sync="visible"  direction="rtl"  @close="close">
      <el-form ref="form" :model="deviceType" label-width="80px" style="padding: 20px">
        <el-form-item prop="id" hidden />
        <el-form-item label="类型编码" prop="code" required>
          <el-input v-model="deviceType.code" placeholder="请输入类型编码" />
        </el-form-item>
        <el-form-item label="分类名称" prop="name" required>
          <el-input v-model="deviceType.name" placeholder="请输入分类名称" />
        </el-form-item>
        <el-form-item label="说明" prop="comment">
          <el-input v-model="deviceType.comment" type="textarea" />
        </el-form-item>
        <el-form-item label="图片" prop="imgUrl">
          <ut-upload v-model="deviceType.imgUrl" />
        </el-form-item>

      </el-form>

      <div class="drawer__footer">
        <el-button class="drawer__footer_item" @close="close">取 消</el-button>
        <el-button class="drawer__footer_item" type="primary" :loading="loading" @click="handleSubmit">{{ loading ? '提交中 ...' : '确 定' }}</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<style scoped>
.drawer__footer{
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 20px;
}
.drawer__footer_item{
  flex: 1;
}
</style>
